import Headroom from 'headroom.js';
import NavMenuSidebar from './nav-menu-sidebar';
import NavAnchorLinkUpdater from './nav-anchor-link-updater';
import SearchOverlay from '~scripts/components/search-overlay';

const NavMenu = {
  _selectors: {
    headerNav: '.js-header-nav',
    menu: '.js-nav-menu',
    menuItemTopLevel: '.js-nav-menu-item-top-level',
    dropdownContainer: '.js-nav-menu-dropdown'
  },

  init() {
    const self = this;

    document
      .querySelector(this._selectors.menu)
      .querySelectorAll(this._selectors.menuItemTopLevel)
      .forEach(node => {

        if ( node.hasAttribute('data-has-children') ) {
          node.addEventListener('mouseenter', this.onMenuShow.bind(this));
          node.addEventListener('mouseleave', this.onMenuHide.bind(this));
        }

        if ( node.hasAttribute('data-mega-menu') ) {
          node.addEventListener('mouseenter', this.onMegaMenuItemEnter.bind(this));
          node.addEventListener('mouseleave', this.onMegaMenuItemLeave.bind(this));

          if ( self.hasShallowTree(node) ) {
            node.classList.add('has-shallow-tree');
          }
        }
      })
    ;

    // Initialises Headroom.js
    const headroom = new Headroom(document.querySelector(this._selectors.headerNav), {
      tolerance : {
        // Gives a bit of margin when scrolling up before showing the menu
        up: 5,
        down: 10
      },
    });
    headroom.init();

    // Initialises sidebar menu
    NavMenuSidebar.init();

    // Initialises anchor link highlighter
    NavAnchorLinkUpdater.init();

    // Initialises Search overlay
    SearchOverlay.init();
  },

  onMenuShow() {
    document.querySelector(this._selectors.headerNav).classList.add('show-overlay');
  },

  onMenuHide() {
    document.querySelector(this._selectors.headerNav).classList.remove('show-overlay');
  },

  onMegaMenuItemEnter(e) {
    const dropdownEl = e.currentTarget.querySelector(this._selectors.dropdownContainer);
    if (this.isDropdownScrollRequired(dropdownEl)) {
      dropdownEl.style.overflow = 'auto';
      dropdownEl.style.height = (window.innerHeight - dropdownEl.offsetTop) + 'px';
    } else {
      dropdownEl.style.overflow = 'hidden';
      dropdownEl.style.height = 'auto';
    }
  },

  onMegaMenuItemLeave(e) {
    const dropdownEl = e.currentTarget.querySelector(this._selectors.dropdownContainer);
    dropdownEl.style.overflow = 'hidden';
    dropdownEl.style.height = 'auto';
  },

  isDropdownScrollRequired(dropdownEl) {
    const bottomPos = dropdownEl.offsetTop + dropdownEl.offsetHeight;
    return bottomPos > window.innerHeight;
  },

  /**
   * Returns whether the current menu item has a short/long tree of descendant items
   */
  hasShallowTree(node) {
    let subMenuTree = {};
    node.querySelectorAll('.js-nav-submenu').forEach(subMenu => {
      const depth = parseInt(subMenu.getAttribute('data-depth'));
      subMenuTree[depth] = subMenu;
    });

    return Object.keys(subMenuTree).length === 2;
  }
};

export default NavMenu;